module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "redundant"
  }, [(_vm.item.attr === 'customerName') ? [_c('associated-field', {
    ref: "associatedField",
    attrs: {
      "module": "customerApi",
      "item": _vm.item,
      "form": _vm.form
    },
    on: {
      "addNew": _vm.addNew,
      "emitObj": _vm.customerChange
    }
  })] : _vm._e(), _vm._v(" "), (_vm.item.attr === 'contractId') ? [(_vm.form.customerName && _vm.form.customerName.id) ? _c('associated-field', {
    ref: "associatedField",
    attrs: {
      "module": "contractApi",
      "item": _vm.item,
      "form": _vm.form,
      "customerId": _vm.form.customerName.id
    },
    on: {
      "addNew": _vm.addNew,
      "emitObj": _vm.contractChange
    }
  }) : _c('span', [_vm._v("无")])] : _vm._e(), _vm._v(" "), (_vm.item.attr === 'products') ? [_c('div', {
    staticClass: "products"
  }, [_c('div', {
    staticClass: "v-area"
  }, [(_vm.form[_vm.item.attr] && _vm.form[_vm.item.attr].length) ? [_vm._v(_vm._s(_vm._f("productLen")(_vm.form[_vm.item.attr])))] : [_vm._v("暂无关联产品")]], 2), _vm._v(" "), _c('span', {
    staticClass: "add-btn",
    on: {
      "click": function($event) {
        _vm.emitParent(_vm.item.nonEditable)
      }
    }
  }, [_vm._v("选择")])]), _vm._v(" "), (_vm.showProduct) ? _c('v-product', {
    ref: "products",
    attrs: {
      "contractId": _vm.form.contractId,
      "select": _vm.form.products,
      "decimalPrecisionMap": _vm.item.decimalPrecisionMap
    },
    on: {
      "close": function($event) {
        _vm.showProduct = false
      },
      "emitProductsData": _vm.updateProducts
    }
  }) : _vm._e()] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6a4dce2f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/fieldtype/refund/index.vue
// module id = 1296
// module chunks = 82